<template>
    <div class="w-full flex flex-col pl-4">
        <field-row :fields="fieldValues"
                   :mode="mode"
                   :subject="'affiliation'"
                   v-on:save="emitMessage('save', $event)"
                   v-on:cancel="emitMessage('cancel', $event)"
                   v-on:edit="emitMessage('edit', $event)"
                   v-on:delete="emitMessage('delete', $event)"
                   :errors="errors"
                   :template-string="':institution | :department | :laboratory | :place | :country_id'"
        ></field-row>
    </div>
</template>

<script>
    export default {
        props: {
            affiliation: {type: Object},
            fields: {type: Array},
            errors: {type: Object},
            mode: {type: String},
            id: {},
        },
        inject: ['translate'],
        data: function () {
            return {
                affiliations: [],
                selectedAffiliationIndex: null,
                affiliationInternal: {},
                fieldValues: [],
                affiliationMode: 'show'
            }
        },
        created: function() {
        },
        mounted() {
            this.affiliationInternal = {...this.affiliation};
            this.fields.forEach((f) => {
                let fieldCopy = {...f}
                fieldCopy.value = this.affiliationInternal[f.field];
                this.fieldValues.push(fieldCopy);
            });

        },
        methods: {
            emitMessage: function(message, payload) {
                payload['id'] = this.id;
                this.$emit(message, payload);
            },
        },
        computed: {},
        watch: {
        }

    }
</script>
